var site = site || {};
var generic = generic || {};

(function ($) {
  Drupal.behaviors.jmDigitalGameFormatterV1 = {
    attach: function (context) {
      var self = this;
      var $gameFormatter = $('.js-digital-game-formatter', context);
      var $cardBack = $('.js-back-card', $gameFormatter);
      var $gameStartContent = $('.js-game-start__content-active', $gameFormatter);
      var $gameRedeemedContent = $('.js-redeemed-offer-content', $gameFormatter);
      var $gameExpiredContent = $('.js-expired-content', $gameFormatter);
      var $gameCTAOptions = $('.js-game-cta-options', $gameFormatter);
      var $gameShopOptions = $('.js-shop-now-options', $gameFormatter);
      var flipCardOfferExist = function () {
        var params = {
          offers: self.offerCodes
        };

        generic.jsonrpc.fetch({
          method: 'offers.getOffersRpcData',
          params: [params],
          onBoth: function (response) {
            var offers = response.getValue().offers;

            if (offers !== undefined && Object.keys(offers).length > 0) {
              self.isOfferValid = true;
            } else {
              $gameStartContent.addClass('hidden');
              $gameExpiredContent.removeClass('hidden');
            }
          }
        });
      };

      $(document).on('flipcard.showRedeemedMessage', function () {
        $gameRedeemedContent.removeClass('hidden');
        $gameStartContent.addClass('hidden');
      });

      self.isOfferValid = false;
      self.offerCodes = [];
      self.offerParams = {};
      self.redeemed = 0;

      $cardBack.each(function (i, ele) {
        var eleOfferCode = $(ele).data('card-offer-code');
        let eleIndex;
        let eleOfferMessage;

        if (eleOfferCode !== undefined) {
          self.offerCodes.push(eleOfferCode);
          eleIndex = parseInt($(ele).data('card-set-index'));
          eleOfferMessage = $(ele).data('card-offer-message');
          self.offerParams[eleIndex] = {
            offer_code: eleOfferCode,
            offer_applied_message: eleOfferMessage,
            offer_applied_image: $(ele).find('.js-redeem-offer-image').data('src')
          };
        }
      });

      if (!generic.cookie('flipgame_has_redeemed')) {
        flipCardOfferExist();
        $gameStartContent.removeClass('hidden');
        $gameRedeemedContent.addClass('hidden');
      } else {
        $(document).trigger('flipcard.showRedeemedMessage');
      }
      $(document).on('flipcard.ApplyOffer', function (offerTarget, offerCode) {
        if (offerCode) {
          var offer_params = {
            offer_code: offerCode
          };

          generic.jsonrpc.fetch({
            method: 'offers.apply',
            params: [offer_params],
            onSuccess: function (res) {
              $gameCTAOptions.addClass('hidden');
              $gameShopOptions.removeClass('hidden');
              generic.cookie('flipgame_has_redeemed', 1);
              self.redeemed = 1;
            }
          });
        }
      });
    }
  };
})(jQuery);
